
import ServiceDetails from "../component/servicedetials"

function ServicesDetilasdrop(){
    return(
        <>
        
        <ServiceDetails/>

        </>
    )
}
export default ServicesDetilasdrop